'use client'
import { useEffect, useRef } from "react"
import { MapMarker, ShapeMarkerProps } from "./types";
import { useMap } from "./MapContext";
import { randomNumber } from "@/migrated-widgets/table-map/utils/random";

const ShapeMarker: React.FC<ShapeMarkerProps> = (props) => {

    const shapes = { circle: google.maps.Circle, rectangle: google.maps.Rectangle };

    const { map, addMarker, removeMarker, infoWindow: mapInfoWindow } = useMap();

    const id = useRef<MapMarker['id']>(props?.id ?? randomNumber());
    const lastOpen = useRef<number>(Date.now());

    useEffect(() => {
        const shapeMarker = new shapes[props.shape]();
        shapeMarker.setOptions({ ...props, map });
        const bounds = shapeMarker.getBounds();
        const center = bounds?.getCenter();
        const position = { lat: center?.lat() ?? 0, lng: center?.lng() ?? 0 };
        shapeMarker.addListener("mouseover", (evt: any) => {
            if (lastOpen.current - Date.now() < 400) {
                if (mapInfoWindow) {
                    mapInfoWindow.current?.close();
                    mapInfoWindow.current = null;
                }

                mapInfoWindow.current = new google.maps.InfoWindow({
                    content: props.label,
                    position: evt.latLng,
                    pixelOffset: new google.maps.Size(0, -10),

                    zIndex: props.zIndex

                });
                mapInfoWindow.current.open(map, shapeMarker);
            }
            lastOpen.current = Date.now();
        });
        shapeMarker.addListener("mouseout", () => {
            mapInfoWindow.current?.close();
        });

        addMarker({
            id: id.current,
            marker: shapeMarker,
            position,
            remove: () => {
                shapeMarker.setMap(null);
                if (mapInfoWindow.current) {
                    mapInfoWindow.current.close();
                    mapInfoWindow.current = null;
                }
            },
            props
        });
        return () => {
            removeMarker(id.current);
        }
    }, [])

    return null;
}

export default ShapeMarker;